<template>
  <div :id="this.id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="ButtonUserComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="parseInt(internal_config.height)" :minWidth="80" :minHeight="30"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-ButtonUserComponent'>
        <img src="../../../../../../static/images/icons/link.svg"
             v-tooltip="{content:$t('ct-option-link'),  class: 'tooltip-custom'}"
             class="svg-icon normal-action"
             @click="linkElement"/>
      </options-element-bar>
      <div class="container-button-members-area">
        <div
          v-bind:style="{height: height, width : width,border : getButtonStyle('border'),'border-radius': getButtonStyle('borderRadius'),background: getButtonStyle('backgroundColor'),'box-shadow': getButtonStyle('boxShadow')}"
          class="btn-members-area" :class="[internal_config.actionsformat, (preview ? 'is-auth': '')]">
          <template v-if="preview">

            <div class="btn-members-area-text" :class="{'btn-member-dropdown' : parseInt(internal_config.withDropdown) }" :style="textButtonStyle()" @click.prevent="toggleDropdown()"
                 v-if="parseInt(internal_config.withDropdown)">
                   <span>
                     <template
                       v-if="internal_config.iconRegards && internal_config.iconRegards.icon && internal_config.iconRegards.position === 'left'">
                         <i :class="this.$addIconPrefix(internal_config.iconRegards.icon)"></i>
                     </template>
                     {{(parseInt(internal_config.withRegards)) ? internal_config.textRegards || $t('ct-hello'): ''}}&nbsp{{$t('ct-exemple-name')}}
                     <template
                       v-if="internal_config.iconRegards && internal_config.iconRegards.icon && internal_config.iconRegards.position === 'right'">
                         <i :class="this.$addIconPrefix(internal_config.iconRegards.icon)"></i>
                     </template>
                    </span>
              <i class="mdi mdi-chevron-down float-right icon-member-dropdow"></i>
            </div>

            <template v-else>
              <div class="btn-members-area-text" :style="textButtonStyle()">
                  <span>
                    <template
                      v-if="internal_config.iconRegards.icon && internal_config.iconRegards.position === 'left'"><i
                      :class="this.$addIconPrefix(internal_config.iconRegards.icon)"></i></template
                    >{{(parseInt(internal_config.withRegards)) ? internal_config.textRegards || $t('ct-hello') : ''}}&nbsp{{ $t('ct-exemple-name') }}<template
                    v-if="internal_config.iconRegards.icon && internal_config.iconRegards.position === 'right'"><i
                    :class="this.$addIconPrefix(internal_config.iconRegards.icon)""></i></template>
                  </span>
              </div>

              <div class="btn-members-area-text" :style="textButtonStyle()">
                  <span>
                    <template v-if="internal_config.iconLogout.icon && internal_config.iconLogout.position === 'left'">
                      <i :class="this.$addIconPrefix(internal_config.iconLogout.icon)"></i>
                    </template
                    >{{ internal_config.textLogout || this.$t('ct-logout')}}<template
                    v-if="internal_config.iconLogout.icon && internal_config.iconLogout.position === 'right'"><i
                    :class="this.$addIconPrefix(nternal_config.iconLogout.icon)"></i>
                    </template>
                  </span>
              </div>
            </template>
          </template>

          <template v-else>
            <div class="btn-members-area-text" :style="textButtonStyle()"
                 v-show="['login-register', 'login'].includes(internal_config.actionsformat)">
                  <span>
                    <template v-if="internal_config.iconLogin.icon && internal_config.iconLogin.position === 'left'"><i
                      :class="this.$addIconPrefix(internal_config.iconLogin.icon)"></i></template
                    >{{ internal_config.textLogin || this.$t('ct-login')}}<template
                    v-if="internal_config.iconLogin.icon && internal_config.iconLogin.position === 'right'"><i
                    :class="this.$addIconPrefix(internal_config.iconLogin.icon)"></i></template>
                  </span>
            </div>
            <!-- <div>|</div> -->
            <div class="btn-members-area-text" :style="textButtonStyle()"
                 v-show="['login-register', 'register'].includes(internal_config.actionsformat)">
                  <span>
                    <template
                      v-if="internal_config.iconRegister.icon && internal_config.iconRegister.position === 'left'">
                      <i :class="this.$addIconPrefix(internal_config.iconRegister.icon)"></i>
                    </template
                    >{{(internal_config.textRegister && internal_config.textRegister.length > 0 ? internal_config.textRegister : this.$t('ct-register'))}}<template
                    v-if="internal_config.iconRegister.icon && internal_config.iconRegister.position === 'right'"><i
                    :class="this.$addIconPrefix(internal_config.iconRegister.icon)"></i>
                    </template>
                  </span>
            </div>
          </template>
        </div>
        <div v-show="internal_config.menuDropdown" class="ma-menu-dropdown"
             :style="{ border : getDropdownStyle('border'),'border-radius': getDropdownStyle('borderRadius'), boxShadow: getDropdownStyle('boxShadow'), backgroundColor: getDropdownStyle('backgroundColor')}">
          <nav>
            <a :style="textDropdownStyle()" href="#" class="ma-dropdown-item">{{ internal_config.textLogout || this.$t('ct-logout')}}</a>
          </nav>
        </div>
      </div>
      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>

<script>

import Data from './Model';
import Resources from './Resources.vue';
import OptionsElementBar from '../../OptionsElementBar';
import MixinComponents from "../../../../../js/mixins/MixinComponents";

export default {
  name: 'ButtonUserComponent',
  props: ['config', 'id', 'preview', 'device'],
  mixins: [MixinComponents],
  components: {
    OptionsElementBar,
    Resources
  },
  computed: {
    boxShadow() {
      return this.internal_config.boxShadow;
    },
    background() {
      return this.internal_config.backgroundColor;
    },
  },
  data() {
    return Data.data();
  },
  watch: {
    'internal_config': {
      deep: true,
      handler(value) {
        this.$eventHub.setValueElementConfig(this.id, value);
      }
    }
  },

  methods: {

    getButtonStyle(config){
      return this.internal_config.buttonStyle[config];
    },

    getDropdownStyle(config){
      return this.internal_config.dropdownStyle[config];
    },

    animation() {
      return true;
    },

    linkElement: function() {
      this.$root.$emit('openButtonUserLinkModal', this, (data) => {
        console.log('');
      });
    },

    onResize: function(x, y, width, height) {
      this.internal_config.width = width + 'px';
      this.internal_config.height = height + 'px';

      this.$refs.resourcesData.setValuesData(this);
    },

    showResources() {
      return this.$refs.resourcesData.getValuesData();
    },

    formatText(textStyle){
      return {
        fontFamily: textStyle.family,
        fontSize: (this.device !== 'mobile' ? textStyle.size : textStyle.sizeMobile),
        'text-align': textStyle.align,
        'font-weight': textStyle.weight,
        'font-style': textStyle.style,
        'text-decoration': textStyle.stroke,
        color: textStyle.color
      };
    },

    textButtonStyle() {
      let textStyle = this.formatText(this.internal_config.buttonStyle.textStyle);
      return {
        borderRadius: this.internal_config.buttonStyle.borderRadius,
        ...{...textStyle}
      };
    },

    textDropdownStyle() {
      return this.formatText(this.internal_config.dropdownStyle.textStyle,this.internal_config.buttonStyle);
    },

    style() {
      return `
        left: ${this.internal_config.left};
        margin: 0 auto;
        zIndex: ${parseInt(this.internal_config.zIndex)};
        max-width: ${this.internal_config.maxWidth};
        paddingTop: ${this.internal_config.paddingTop};
        padding-left: ${this.internal_config.paddingLeft};
        padding-right: ${this.internal_config.paddingRight};
        padding-bottom: ${this.internal_config.paddingBottom};
        top: ${this.internal_config.top}
        `;
    },

    toggleDropdown(){
      var value = !this.internal_config.menuDropdown;
      this.internal_config = Object.assign({}, this.internal_config, { menuDropdown : value });
    },
  },
  created() {
    this.internal_config = Object.assign({}, this.internal_config, window.mergeRecursive(this.props, this.$props.config));
    this.internal_config.menuDropdown = false;
  },

  mounted() {
    this.$refs.resourcesData.setValuesData(this);

    if (this.$props.preview) {
      this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');
      this.$el.classList.add('preview');
    }

    let vm = this;

    this.$el.querySelectorAll('.btn-members-area-text').forEach(function(element) {
      element.addEventListener('mouseover', function () {
        document.body.style.setProperty('--button-user-background-color--hover', vm.internal_config.buttonStyle.backgroundColorHover);
        document.body.style.setProperty('--button-user-text-color--hover', vm.internal_config.buttonStyle.textColorHover);
      });
    });

    this.$el.querySelectorAll('.ma-dropdown-item').forEach(function(element) {
      element.addEventListener('mouseover', function () {
        document.body.style.setProperty('--dropdown-user-background-color--hover', vm.internal_config.dropdownStyle.backgroundColorHover);
        document.body.style.setProperty('--dropdown-user-text-color--hover', vm.internal_config.dropdownStyle.textColorHover);
      });
    });
  }
};
</script>

<style lang="scss">

  .container-button-members-area {
    display: inline-flex;
    flex-direction: column;
    width: 100%;

    .ma-menu-dropdown {
      display: flex;
      flex-direction: column;

      &:hover{
        background-color: var(--dropdown-user-background-color--hover) !important;

        .ma-dropdown-item {
          color: var(--dropdown-user-text-color--hover) !important;
        }
      }

      .ma-dropdown-item {
        display: block;
        width: 100%;
        padding: .25rem 1.5rem;
        font-weight: 400;
        text-align: inherit;
        white-space: nowrap;
        transition: 500ms all;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .ma-dropdown-divider {
        height: 0;
        margin: .25rem 1rem;
        overflow: hidden;
        border-top: 1px solid #e9ecef;
      }
    }
  }

  .btn-members-area {
    display: inline-flex;
    flex-direction: row;

    &.register:not(.is-auth), &.login:not(.is-auth) {
      .btn-members-area-text {
        min-width: 100% !important;
        max-width: 100% !important;
      }
    }

    &.is-auth{
      .btn-member-dropdown{
        width: 100%;
      }
      .btn-members-area-text:not(.btn-member-dropdown):first-child{
        flex: 2;
        max-width: 65%;
      }
      .btn-members-area-text:not(.btn-member-dropdown):last-child{
        flex: 1;
        padding: 0 5px;
        max-width: 35%;
      }
    }

    &:not(.is-auth){
      .btn-members-area-text{
        max-width: 50%;
      }

      .btn-members-area-text {
        &:not(.btn-member-dropdown) {

          span {
            max-width: 100%;
          }
        }
      }
    }

    .btn-members-area-text {
      display: inline-flex;
      cursor: pointer;
      flex: 1;
      height: 100%;
      padding-right: 10px;
      padding-left: 10px;
      justify-content: space-between;
      align-items: center;

      &:hover{
        background-color: var(--button-user-background-color--hover) !important;
        color: var(--button-user-text-color--hover) !important;
      }

      .icon-member-dropdown{
        min-width: 10%;
        text-align: right;
      }

      &:first-child:not(.btn-member-dropdown){
        span{
          max-width: 100%;
        }
      }
      span {
        display: table-cell;
        flex: 1;
        vertical-align: middle;
        max-width: 90%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: inherit;
        i {
          margin-right: 5px;
          margin-left: 5px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Members/ButtonUser/ButtonUser.vue